import { HTTPErrorCallback } from "@soft-db/http";
import { useHTTP } from "@soft-db/http/vue";

export function useHttpError(cb: HTTPErrorCallback) {
	const http = useHTTP();

	const stop = http.onError(cb, false);

	onScopeDispose(stop);
}
